<!--
  app/components/pages/how-to-play/HtpSectionDuration.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";
import ContextLogoCrown from "~/components/context-shared/ContextLogoCrown.vue";
import HtpIconStopwatch from "./HtpIconStopwatch.vue";
import HtpIconChrono from "./HtpIconChrono.vue";

const { $t } = useNuxtApp();
</script>

<template>
  <section id="duration" class="scroll-mt-48">
    <div
      class="flex flex-col bigsm:flex-row bigsm:items-baseline gap-1 bigsm:gap-4 mb-6 pb-2 bigsm:border-b bigsm:border-gray-700"
    >
      <div
        class="flex items-baseline gap-3 shrink-0 border-b border-gray-700 pb-2 bigsm:pb-0 bigsm:border-none"
      >
        <span class="text-primary shrink-0 self-center"><ContextLogoCrown :width="28" :height="28" /></span>
        <h2 class="font-kings text-3xl bigsm:text-4xl uppercase">
          {{ $t("howToPlay.section.duration.title") }}
        </h2>
      </div>
      <p class="text-gray-400 text-sm pl-6 bigsm:pl-0 pt-2 bigsm:pt-0">
        {{ $t("howToPlay.section.duration.subtitle") }}
      </p>
    </div>

    <div class="flex flex-wrap items-center gap-6 bigsm:gap-10 px-6">
      <span class="mx-auto text-primary shrink-0 mt-1">
        <HtpIconStopwatch :width="110" :height="100" />
      </span>

      <div class="flex flex-col gap-4 mx-auto bigsm:flex-1">
        <!-- 20 min -->
        <div class="flex items-center gap-3">
          <span class="text-primary shrink-0">
            <HtpIconChrono number="20" :width="38" :height="43" />
          </span>
          <p class="font-kings leading-none uppercase">
            <span class="text-primary text-5xl bigsm:text-6xl italic mr-2">1</span>
            <span class="text-white text-2xl bigsm:text-3xl">
              {{ $t("howToPlay.section.duration.of") }}
            </span>
            <span class="text-primary text-2xl bigsm:text-3xl"> 20</span>
            <span class="text-white text-2xl bigsm:text-3xl"> MIN</span>
          </p>
        </div>

        <!-- 16 min + Matchball -->
        <div>
          <div class="flex items-center gap-3">
            <span class="text-primary shrink-0">
              <HtpIconChrono number="16" :width="38" :height="43" />
            </span>
            <div class="flex flex-col gap-1">
              <p class="font-kings leading-none uppercase">
                <span class="text-primary text-5xl bigsm:text-6xl italic mr-2">1</span>
                <span class="text-white text-2xl bigsm:text-3xl">
                  {{ $t("howToPlay.section.duration.of") }}
                </span>
                <span class="text-primary text-2xl bigsm:text-3xl"> 16</span>
                <span class="text-white text-2xl bigsm:text-3xl"> MIN</span>
              </p>
              <span
                class="font-kings text-sm bigsm:text-lg italic uppercase pr-4"
                :style="{
                  background:
                    'linear-gradient(91.93deg, #8d6d27 -13.52%, #a98e53 14.37%, #e7d6b2 62.01%, #dcbb72 102.68%)',
                  '-webkit-background-clip': 'text',
                  '-webkit-text-fill-color': 'transparent',
                  'background-clip': 'text',
                }"
                >{{ $t("howToPlay.section.duration.second") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
